'use es6';

import { GROUP_KEYS } from 'getting-started-shared-tasks/gettingStartedGroupKeys';
import { ONBOARDING_CMS_SIMPLIFIED } from 'getting-started-shared-tasks/onboardingKeys';
import { ONBOARDING_VIEWS } from 'user-context/onboardingSettings';
import { CMS_HUB_INTEREST } from '../constants/surveyConstants';
import { HubletUrl } from '../utils/urls';
import { CMS_FREE_SIGNUP } from '../constants/signupConstants';
const cmsExperiencesChecks = [{
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
      view: ONBOARDING_VIEWS.CMS,
      onboardingKey: ONBOARDING_CMS_SIMPLIFIED,
      groupKey: GROUP_KEYS.cmsV3
    };
  },
  checks: [{
    survey: {
      hubInterest: CMS_HUB_INTEREST
    }
  }]
}, {
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
      view: ONBOARDING_VIEWS.CMS,
      onboardingKey: ONBOARDING_CMS_SIMPLIFIED,
      groupKey: GROUP_KEYS.cmsV3
    };
  },
  checks: [{
    signupType: CMS_FREE_SIGNUP
  }]
}];
export default cmsExperiencesChecks;